import { AxiosStatic, AxiosResponse } from "axios";

import * as moment from "moment";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { EmployeeDocument } from "./model";

export class EmployeeDocumentApi {
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async getAll(customerId: string, employeeRecordId: string): Promise<EmployeeDocument[]> {
        const response = await this.axios.get<
            undefined,
            AxiosResponse<ServerModelWithDateStrings<EmployeeDocument>[]>,
            ServerModelWithDateStrings<EmployeeDocument>[]
        >(`/api/customer/${customerId}/employeerecord/${employeeRecordId}/document`);
        return response.data.map(this.parseModel);
    }

    public async getCount(customerId: string, employeeRecordId: string): Promise<number> {
        const response = await this.axios.get<number>(`/api/customer/${customerId}/employeerecord/${employeeRecordId}/document/count`);
        return response.data;
    }
    public async delete(customerId: string, employeeRecordId: string, employeeDocumentId: string): Promise<void> {
        await this.axios.delete(`/api/customer/${customerId}/employeerecord/${employeeRecordId}/document/${employeeDocumentId}`);
    }

    public parseModel(model: ServerModelWithDateStrings<EmployeeDocument>): EmployeeDocument {
        return {
            ...model,
            dateCreated: model.dateCreated ? moment(model.dateCreated) : undefined,
        };
    }
}
